import React, { useEffect, useState } from "react";
import EditModal from "./shared/EditModal";
import { MdEdit, MdDelete } from "react-icons/md";
import SUG from "./shared/suggestions";
import { FaFileAlt } from "react-icons/fa";

export default function InternshipsSection({ value = [], onChange }) {
  const [items, setItems] = useState(value || []);
  const [open, setOpen] = useState(false);
  const [editIdx, setEditIdx] = useState(null);

  useEffect(() => setItems(value || []), [value]);

  // ✅ Added upload and recommendation fields
  const fields = [
    { name: "company", label: "Company", type: "text", suggestList: SUG.companies },
    { name: "role", label: "Role", type: "text" },
    { name: "location", label: "Location", type: "text", suggestList: SUG.locations },
    { name: "start", label: "Start Date", type: "text", placeholder: "YYYY-MM" },
    { name: "present", label: "Present", type: "checkbox" },
    { name: "endYear", label: "End Date", type: "text", placeholder: "YYYY-MM" },
    { name: "description", label: "Description", type: "textarea" },
    {
      name: "pdf",
      label: "Upload Certificate",
      type: "file",
      accept: ".pdf",
      showFileName: true, // 👈 custom flag to show filename
    },
    // { name: "recommendation", label: "Letter of Recommendation", type: "checkbox" },
  ];

  const openAdd = () => {
    setEditIdx(null);
    setOpen(true);
  };

  const openEdit = (i) => {
    setEditIdx(i);
    setOpen(true);
  };

  const save = (data) => {
    const next = [...items];
    if (editIdx == null) next.push(data);
    else next[editIdx] = data;
    setItems(next);
    onChange(next);
  };

  const remove = (i) => {
    const next = items.filter((_, idx) => idx !== i);
    setItems(next);
    onChange(next);
  };

  return (
    <section className="ccard">
      <div className="card-head">
        <h3>Internships</h3>
        <div className="card-actions">
          <button className="link" onClick={openAdd}>
            Add
          </button>
        </div>
      </div>

      <div className="card-body">
        {items.length === 0 ? (
          <p className="muted">No internships</p>
        ) : (
          items.map((it, i) => (
            <div className="item-row" key={i}>
              <div>
                <div className="item-title">
                  {it.company} — {it.role}
                </div>
                <div className="muted">
                  {it.location && <>{it.location} | </>}
                  {it.start} to {it.present ? "Present" : it.endYear}
                </div>

                {it.description && (
                  <div className="smalll muted">{it.description}</div>
                )}

                {/* ✅ Show PDF link */}
                {it.pdf && (
                  <div className="smalll muted">
                    <FaFileAlt className="fi"/>{" "}
                    <a
                      href={it.pdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#2563eb" }}
                    >
                      {it.pdfName || "View Certificate"}
                    </a>
                  </div>
                )}

                {/* ✅ Letter of Recommendation */}
                {/* {it.recommendation && (
                  <div className="smalll muted">
                    <FaMedal className="fim"/> Letter of Recommendation is there
                  </div>
                )} */}
              </div>

              <div className="item-actions">
                <MdEdit
                  title="Edit"
                  className="smalll"
                  onClick={() => openEdit(i)}
                />
                <MdDelete
                  title="Delete"
                  className="smalll danger"
                  onClick={() => remove(i)}
                />
              </div>
            </div>
          ))
        )}
      </div>

      {open && (
        <EditModal
          title={editIdx == null ? "Add Internship" : "Edit Internship"}
          initial={editIdx == null ? {} : items[editIdx]}
          fields={fields}
          onClose={() => setOpen(false)}
          onSave={(data) => {
            // ✅ Store file name and preview URL
            if (data.pdf && data.pdf instanceof File) {
              const fileUrl = URL.createObjectURL(data.pdf);
              data.pdf = fileUrl;
              data.pdfName = data.pdf.name || "Uploaded Certificate.pdf";
            }
            save(data);
            setOpen(false);
          }}
        />
      )}
    </section>
  );
}
